import {
  isEffectiveOpenRouterTransport,
  loadOpenRouterRoutingEnv,
} from "../sync/openRouterRoutingEnv.js";
import type { ModelResolutionSuccess } from "../sync/modelNameResolver/types.js";
import { resolveOpenRouterApiKey, resolvePreferOpenRouterPreference } from "./preferOpenRouter.js";
import type { InvokeRouterConfigSlice, PreferOpenRouterOptions } from "./types.js";
import type { OpenRouterRoutingConfig } from "../sync/openRouterRoutingEnv.js";

export type ApplyOpenRouterInvokeRoutingOptions = {
  routingEnv?: OpenRouterRoutingConfig;
  preferOpenRouter?: boolean | PreferOpenRouterOptions;
  openRouterApiKey?: string;
  resolution?: Pick<ModelResolutionSuccess, "routedViaOpenRouter">;
};

/**
 * Set router proxy flags when OpenRouter transport is effective and API key is present.
 */
export function applyOpenRouterInvokeRouting(
  routerSlice: InvokeRouterConfigSlice,
  options: ApplyOpenRouterInvokeRoutingOptions = {},
): InvokeRouterConfigSlice {
  const apiKey = resolveOpenRouterApiKey(options.openRouterApiKey);
  if (!apiKey) return routerSlice;

  const routingEnv = options.routingEnv ?? loadOpenRouterRoutingEnv();
  const resolution = options.resolution;

  const preferOpenRouter = resolvePreferOpenRouterPreference(options.preferOpenRouter);

  const viaOpenRouter =
    resolution?.routedViaOpenRouter === true ||
    (resolution?.routedViaOpenRouter !== false &&
      isEffectiveOpenRouterTransport(routingEnv, {
        provider: routerSlice.provider,
        modelId: routerSlice.model,
        routeViaOpenRouter: preferOpenRouter,
      }));

  if (viaOpenRouter) {
    routerSlice.allowOpenRouterProxy = true;
    if (routerSlice.provider && routerSlice.provider !== "openrouter") {
      routerSlice.providerProxy = "openrouter";
    }
  } else {
    routerSlice.allowOpenRouterProxy = false;
  }

  return routerSlice;
}
